export const DetailedReportPage = () => <main />;
